import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useAuth = ({ authRequired, redirectTo }) => {
  const isLoggedin = useSelector((state) => state.user.isLoggedin);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedin && !authRequired) {
      navigate(redirectTo);
    }
    if (!isLoggedin && authRequired) {
      navigate(redirectTo);
    }
  }, [isLoggedin]);
};

export default useAuth;
